module.exports = __webpack_public_path__ + "kudos_75.svg?f52ad37571a28f80eab02e94c66e5671";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_75.svg
// module id = 178
// module chunks = 0